module.exports = __webpack_public_path__ + "static/img/video.5faf14bf.svg";